import { Outlet, useLocation } from 'react-router-dom';
import type { HierarchyLevel } from '@/shared/types';
import { TopBar } from '@/versions/v1/chrome/TopBar';
import { AppSidebar } from '@/versions/v1/chrome/AppSidebar';
import { SeededAnnouncementBanner } from '@/versions/v1/chrome/AnnouncementBanner';
import { ProductTopBar } from '@/versions/v1/modules/_chrome/ProductTopBar';
import { Walkthrough } from '@/versions/v1/chrome/Walkthrough';
import { Drawer } from '@/versions/v1/chrome/Drawer';
import { AIRail } from '@/versions/v1/chrome/AIRail';
import { AppShellPanels } from '@/versions/v1/chrome/AppShellPanels';
import { ThreadSpotlight } from '@/versions/v1/chrome/chat/ThreadSpotlight';
import { isChatFirstPath } from '@/versions/v1/shared/project-sidebar-nav';
import { useWalkthroughSync } from './use-walkthrough-sync';

function levelForPath(path: string): HierarchyLevel {
  if (path === '/login') return 'auth';
  if (path === '/' || path === '') return 'workspace';
  if (path.startsWith('/admin') || path.startsWith('/settings')) return 'workspace';
  if (path.startsWith('/projects/')) return 'project';
  return 'workspace';
}

export function AppLayout() {
  const location = useLocation();
  const level = levelForPath(location.pathname);
  const chatFirst = isChatFirstPath(location.pathname);
  const showAIRail = level !== 'auth' && !chatFirst;

  useWalkthroughSync();

  return (
    <div className="flex flex-col h-screen overflow-hidden text-ink-secondary">
      <SeededAnnouncementBanner />
      {level !== 'auth' ? <ProductTopBar level={level} /> : null}

      <main className="flex-1 flex overflow-hidden min-h-0">
        <AppSidebar />

        <AppShellPanels
          showRail={showAIRail}
          chrome={level !== 'auth' ? <TopBar level={level} /> : null}
          main={<Outlet />}
          rail={<AIRail />}
        />
      </main>

      <Drawer />
      <Walkthrough />
      <ThreadSpotlight />
    </div>
  );
}
